import {PriceStore} from "../store/price.store";
import {solutionItems} from "../items/tariff-plans-prices/solutionItems";
import { numberConnections } from '../common/consts';

export class FeedbackComponent {
    private feedbackButtons: HTMLElement[];
    private defaultNumberConnections: HTMLElement[];

    constructor(
        private container: HTMLElement,
        private priceStore: PriceStore,
    ) {
        this.feedbackButtons
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-feedback-btn]'));
        this.defaultNumberConnections = Array.prototype.slice.call(this.container.querySelectorAll('[data-default-number-connections]'));
    }
    public initialize(): void {
        const countConnections: number[] = structuredClone(numberConnections);
        const solutions: {cloud: [string, string, string], server:[string, string]} = {
            cloud: ['Свобода', 'Бизнес', 'Корпорация'],
            server: ['Корпорация плюс', 'Корпорация плюс ФСТЭК']
        }

        this.feedbackButtons.forEach((feedbackButton: HTMLElement, index: number) => {
            feedbackButton.addEventListener('click', () => {
                const objectSliderConnections: Record<number, number> = this.priceStore.getIndexSliderConnections();
                const solution = solutionItems[this.priceStore.gerSolutionIndex()];
                if (solution) {
                    const indexSliderConnections = objectSliderConnections[index] ?? 0;
                    const feedbackQuery: string | undefined = feedbackButton?.dataset.feedbackBtn;
                    const connections = objectSliderConnections[index] ? countConnections[indexSliderConnections]
                      : this.defaultNumberConnections[index]?.dataset.defaultNumberConnections;

                    const buyParams = feedbackQuery === 'купить' ? `&connections=${connections}` : '';
                    const feedback = feedbackQuery
                        ? '?form=' + feedbackQuery + buyParams + '&solution=' + solutions[solution][index]
                        : '';
                    document.location.href = '/обратная-связь' + feedback
               }
            });
        });
    }
}
